// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { TargetTypeSchema } from '../inputTypeSchemas/TargetTypeSchema'
import { ExecutionTypeSchema } from '../inputTypeSchemas/ExecutionTypeSchema'
import { AgentExecutionStatusSchema } from '../inputTypeSchemas/AgentExecutionStatusSchema'
import { ActorTypeSchema } from '../inputTypeSchemas/ActorTypeSchema'

/////////////////////////////////////////
// EXECUTION SCHEMA
/////////////////////////////////////////

export const ExecutionSchema = z.object({
  targetType: TargetTypeSchema,
  executionType: ExecutionTypeSchema,
  status: AgentExecutionStatusSchema,
  actorType: ActorTypeSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  targetId: z.string(),
  craftName: z.string().nullable(),
  craftDescription: z.string().nullable(),
  objective: z.string(),
  metadata: JsonValueSchema.nullable(),
  statusDescription: z.string().nullable(),
  duration: z.number().int().nullable(),
  completedAt: z.coerce.date().nullable(),
  actorId: z.string().nullable(),
  seen: z.boolean().nullable(),
  archived: z.boolean().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Execution = z.infer<typeof ExecutionSchema>

export default ExecutionSchema;
